// Various string marks to be used in performance.mark(string) and performance.measure(string) when measuring latency across our app
export const PERFORMANCE_MARKS = {
  MULTI_ANSWERS: {
    FETCH_START: "multi-answers:fetch-start",
    ANSWERS_RENDERED: "multi-answers:rendered",
  },
};
